import React from 'react'
import { Spin } from 'antd';
import { connect } from "react-redux";
import Modal from '../publicComponents/modal'
import { addSubscriptionMails } from '../actions/actions'


const style = {
    position: 'relative',
    left: 0,
    bottom: 0,
    width: '100%',
    color: 'white',
    textAlign: 'center',

}

class FooterMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            emailId: '',
            isEmailSubscribed: false,
            visible: false,
            isContentLoading: false,
            message: "Saved Successfully",
            isEmailInValid: false
        }
    }
    handleKeyPress = (event) => {
        this.setState({
            emailId: event.target.value
        })
    }
    handleSubscriptions = (event) => {
        const { emailId } = this.state;
        this.setState({
            isContentLoading: true
        })
        if (emailId) {
            this.props.addSubscriptionMails(emailId).then(() => {
                const { subscribedEmails } = this.props;
                if (subscribedEmails) {
                    this.setState({
                        isEmailSubscribed: true,
                        visible: true,
                        isContentLoading: false,
                        emailId: '',
                        isEmailInValid: false
                    })
                }
            })
        }
        else {
            this.setState({
                isContentLoading: false,
                message: "Please input valid subscription Email ID",
                isEmailInValid: true
            })
        }
    }
    setModalStatus = (status) => {
        this.setState({
            visible: status,
            isEmailInValid: status
        })
    }
    render() {
        const { isEmailSubscribed, visible, isContentLoading, emailId, message, isEmailInValid } = this.state;
        return (
            <Spin tip="" spinning={isContentLoading}>
                {isEmailSubscribed &&
                    <Modal getModalStatus={this.setModalStatus} visible={visible} message={message} />
                }
                {isEmailInValid && <Modal getModalStatus={this.setModalStatus} visible={isEmailInValid} message={message} />}
                <footer className="home-footer" style={style}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="subscribe-form-wraper">
                                    <div className="form-group">
                                        <input value={emailId} onChange={this.handleKeyPress} type="text" className="form-control" placeholder="Subscribe for upcoming events & latest Bayans" />
                                    </div>
                                    <div className="form-group">
                                        <button className="btn btn-primary" onClick={this.handleSubscriptions}>Subscribe Now</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </Spin>
        )
    }
}
const mapStateToProps = (state, props) => {
    const { homeData } = state
    if (homeData)
        return {
            subscribedEmails: homeData,
        }
    return {
        subscribedEmails: null,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        addSubscriptionMails: (emailId) =>
            dispatch(addSubscriptionMails(emailId)),
    }

}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FooterMenu);